import {
    Box,
    Column,
    FlexBox,
    SelectionSetInput,
    SelectionSetLabel,
    SelectionSetTileDescription,
    SelectionSetTilePrice,
    Typography,
    tokens,
    tokensRaw,
} from '@vp/swan';
import styled from 'styled-components';
import { Currency, PriceFromFloat } from '@99designs/design-services-common';
import type { FeatureKey, Features } from '../pageData/featuresConfig';
import type { Tier } from '../pageData/tierConfig';

const StyledMobileFlexBox = styled(FlexBox)`
    @media (min-width: ${tokensRaw.SwanBaseBreakpointXsEnd}) {
        display: none !important;
    }
`;

const StyledDesktopFlexBox = styled(FlexBox)`
    @media (max-width: ${tokensRaw.SwanBaseBreakpointXsEnd}) {
        display: none !important;
    }
`;

const displayedFeatures: FeatureKey[] = ['turnaroundTime', 'revisions', 'matchingDesignDetails'];

export const TierSelectionInput = (tier: Tier) => {
    const { id, icon, title, description, features } = tier;
    return (
        <Column span={6} key={id} px={3}>
            <SelectionSetInput value={id}>
                <SelectionSetLabel style={{ borderRadius: tokens.SwanBaseBorderRadius400 }} px={4}>
                    {/* Breakpoint = XS */}
                    <StyledMobileFlexBox flexDirection="row" justifyContent="space-between">
                        <Box display="flex" mr={5}>
                            <Box style={{ flexShrink: 0 }}>{icon}</Box>
                            <Box mb={1} ml={3}>
                                <Typography fontSize="large" fontSkin="title-subsection" mt={1}>
                                    {title}
                                </Typography>
                                <SelectionSetTileDescription
                                    fontSize="small"
                                    fontSkin="body-small"
                                    my={3}
                                >
                                    {description}
                                </SelectionSetTileDescription>

                                {renderFeatures(features, displayedFeatures)}
                            </Box>
                        </Box>

                        <Box>
                            <SelectionSetTilePrice
                                fontSize="large"
                                fontSkin="title-subsection"
                                display="inline-block"
                                style={{ whiteSpace: 'nowrap' }}
                            >
                                <PriceFromFloat
                                    amount={tier.price.amount}
                                    currency={tier.price.currency as Currency}
                                />
                            </SelectionSetTilePrice>
                        </Box>
                    </StyledMobileFlexBox>

                    {/* Breakpoint > XS */}
                    <StyledDesktopFlexBox
                        flexDirection="column"
                        justifyContent="space-between"
                        style={{ height: '100%' }}
                    >
                        <Box mb={2}>
                            {icon}

                            <Typography fontSize="large" fontSkin="title-subsection" mt={1}>
                                {title}
                            </Typography>
                            <SelectionSetTileDescription
                                fontSize="small"
                                fontSkin="body-small"
                                my={3}
                            >
                                {description}
                            </SelectionSetTileDescription>
                            {renderFeatures(features, displayedFeatures)}
                        </Box>

                        <Box mt={3}>
                            <SelectionSetTilePrice fontSize="large" fontSkin="title-subsection">
                                <PriceFromFloat
                                    amount={tier.price.amount}
                                    currency={tier.price.currency as Currency}
                                />
                            </SelectionSetTilePrice>
                        </Box>
                    </StyledDesktopFlexBox>
                </SelectionSetLabel>
            </SelectionSetInput>
        </Column>
    );
};

const renderFeatures = (features: Features, displayedFeatures: Array<keyof Features>) => {
    return (
        <FlexBox mt={1} flexDirection={'column'}>
            {displayedFeatures.map((featureKey) => {
                const feature = features[featureKey];
                return (
                    <FlexBox mt={1} key={featureKey}>
                        {feature.icon}
                        <Typography fontSize="small" fontSkin="body-small" ml={3}>
                            {feature.description?.amount && `${feature.description?.amount} `}
                            {feature.description?.text}
                        </Typography>
                    </FlexBox>
                );
            })}
        </FlexBox>
    );
};
